import { defineMessages } from "@/i18n";
import en from "./en";

export const storesNoticesMessages = defineMessages("stores-notices", en);
